import {AuthModel, UserModel} from './_models'
import jwtDecode from 'jwt-decode'

const AUTH_LOCAL_STORAGE_KEY = 'kt-auth-react-v'
// Versioned storage keys for cache busting on app updates
const APP_VERSION = process.env.REACT_APP_VERSION || '1.0'
const AUTH_STORAGE_ACCESS_TOKEN = `vaarwegenwijs-access-v${APP_VERSION}`
const AUTH_STORAGE_REFRESH_TOKEN = `vaarwegenwijs-refresh-v${APP_VERSION}`

// Request queue for handling multiple 401 errors during token refresh
let isRefreshing = false
let failedQueue: Array<{
  resolve: (token: string) => void
  reject: (error: any) => void
}> = []

const processQueue = (error: any, token: string | null = null) => {
  failedQueue.forEach((prom) => {
    if (error) {
      prom.reject(error)
    } else if (token) {
      prom.resolve(token)
    }
  })
  failedQueue = []
}

const getAuthJWT = (): AuthModel | undefined => {

  if (!localStorage) {
    return
  }

  const lsValue: string | null = localStorage.getItem(AUTH_STORAGE_ACCESS_TOKEN)  
  if (!lsValue) {
    return
  }


  try {
    var auth: AuthModel = jwtDecode(lsValue) 
    auth.access = lsValue
    // const auth: AuthModel = JSON.parse(lsValue) as AuthModel
    if (auth) {
      // You can easily check auth_token expiration also
      return auth
    }
  } catch (error) {
    console.error('AUTH LOCAL STORAGE PARSE ERROR', error)
  }
}

// Save the JWT access and refresh tokens to local storage
const setAuthJWT = (auth: AuthModel) => {
  if (!localStorage) {
    return
  }

  try {
    localStorage.setItem(AUTH_STORAGE_ACCESS_TOKEN, auth.access)
    if (auth.refresh) {
      localStorage.setItem(AUTH_STORAGE_REFRESH_TOKEN, auth.refresh)
    }
  } catch (error) {
    console.error('AUTH LOCAL STORAGE SAVE ERROR', error)
  }
}

// Get refresh token from local storage
const getRefreshToken = (): string | null => {
  if (!localStorage) {
    return null
  }
  return localStorage.getItem(AUTH_STORAGE_REFRESH_TOKEN)
}

// const removeAuth = () => {
//   if (!localStorage) {
//     return
//   }

//   try {
//     localStorage.removeItem(AUTH_LOCAL_STORAGE_KEY)
//     localStorage.removeItem(AUTH_STORAGE_ACCESS_TOKEN)
//   } catch (error) {
//     console.error('AUTH LOCAL STORAGE REMOVE ERROR', error)
//   }
// }

const removeAuthJWT = () => {
  if (!localStorage) {
    return
  }

  try {
    localStorage.removeItem(AUTH_STORAGE_ACCESS_TOKEN)
    localStorage.removeItem(AUTH_STORAGE_REFRESH_TOKEN)
  } catch (error) {
    console.error('AUTH LOCAL STORAGE REMOVE ERROR', error)
  }
}


export function setupAxios(axios: any) {
  axios.defaults.headers.Accept = 'application/json'

  // Request interceptor - automatically add Authorization header to all requests
  axios.interceptors.request.use(
    (config: any) => {
      const token = localStorage.getItem(AUTH_STORAGE_ACCESS_TOKEN)
      if (token) {
        config.headers.Authorization = `Bearer ${token}`
      }
      return config
    },
    (err: any) => Promise.reject(err)
  )

  // Response interceptor - handle 401 errors and refresh token with queue
  axios.interceptors.response.use(
    (response: any) => response,
    async (error: any) => {
      const originalRequest = error.config

      // Skip refresh endpoint to prevent infinite loops
      if (originalRequest?.url?.includes('/token/refresh/')) {
        return Promise.reject(error)
      }

      // If 401 error and we haven't tried to refresh yet
      if (error.response?.status === 401 && !originalRequest._retry) {
        // If already refreshing, queue this request
        if (isRefreshing) {
          return new Promise((resolve, reject) => {
            failedQueue.push({ resolve, reject })
          })
            .then((token) => {
              originalRequest.headers.Authorization = `Bearer ${token}`
              return axios(originalRequest)
            })
            .catch((err) => Promise.reject(err))
        }

        originalRequest._retry = true
        isRefreshing = true

        const refreshToken = getRefreshToken()
        if (refreshToken) {
          try {
            // Use a new axios instance to avoid interceptor loop
            const response = await axios.post(
              `${process.env.REACT_APP_API_URL}/token/refresh/`,
              { refresh: refreshToken }
            )
            const newAccessToken = response.data.access

            // Save new access token (and new refresh token if rotated)
            localStorage.setItem(AUTH_STORAGE_ACCESS_TOKEN, newAccessToken)
            if (response.data.refresh) {
              localStorage.setItem(AUTH_STORAGE_REFRESH_TOKEN, response.data.refresh)
            }

            // Process queued requests with new token
            processQueue(null, newAccessToken)

            // Update the original request with new token and retry
            originalRequest.headers.Authorization = `Bearer ${newAccessToken}`
            return axios(originalRequest)
          } catch (refreshError) {
            // Refresh failed - reject queued requests and redirect to login
            processQueue(refreshError, null)
            removeAuthJWT()
            window.location.href = '/auth?session_expired=true&reason=refresh_failed'
            return Promise.reject(refreshError)
          } finally {
            isRefreshing = false
          }
        } else {
          // No refresh token available - reject queued requests and redirect to login
          processQueue(new Error('No refresh token'), null)
          isRefreshing = false
          removeAuthJWT()
          window.location.href = '/auth?session_expired=true&reason=no_refresh_token'
          return Promise.reject(error)
        }
      }
      return Promise.reject(error)
    }
  )
} 

async function getPostRequestHeader() {
  // refresh token every time new request is made
  console.log('IMPORTANT: ', localStorage.getItem(AUTH_STORAGE_ACCESS_TOKEN))
  if (localStorage.getItem(AUTH_STORAGE_ACCESS_TOKEN) != null){
      console.log('there is a access token in local storage')
      // better to have the actuall credentials of the current user
      // const refreshToken = await getRefreshToken('p.vanklaveren@dotxcontrol.com', 'Hello122;')
      // const AccessToken = await refreshAccessToken(refreshToken)
      // await updateData(JSON.stringify(AccessToken))
      let AccessToken = localStorage.getItem(AUTH_STORAGE_ACCESS_TOKEN)
      const headers = {
          'accept': 'application/json',
          'Authorization': 'Bearer ' + AccessToken,
      } 
      console.log(headers)
      return headers
  }
}

export {setAuthJWT, getAuthJWT, removeAuthJWT, getRefreshToken, getPostRequestHeader, AUTH_STORAGE_ACCESS_TOKEN, AUTH_STORAGE_REFRESH_TOKEN}
